// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"da7485c6","195":"d3f1df07","380":"c3021994","472":"e2a4d026","484":"b2b12927","520":"40b8ade8","728":"da7485c6","760":"0daccbf3","925":"cfbbacef"}[chunkId] + ".chunk.css";
};